<template>
  <div class="company">
    <div class="top">
      <img :src="$apiBaseUrl+top" style="width: 100%;height: 450px">
    </div>
    <div class="con_data">
      <h1 class=" blue center">新闻动态</h1>
      <div class="content">
        <div class="row" v-for="(item,index) in comData" :key="index">
          <div class="row_img">
            <router-link :to="{path:'/newDetails',query:{Id:item.Id}}"><img :src="$apiBaseUrl+item.NewsImg" style="width: 260px;height: 160px"></router-link>
          </div>
          <div class="con_text">
            <div class="bt">
              <router-link :to="{path:'/newDetails',query: {Id:item.Id}}">{{item.NewsTitle}}</router-link>
            </div>
            <div class="date">{{item.CreateTime}}</div>
            <div class="text">HBDZ100-ABC是一款能将压电型加速度计信号处理成加速度、速度及位移量并将其通过无线方式发送到无线路由器的无线振动采集器</div>
          </div>
        </div>

      </div>
    </div>

<!--    &lt;!&ndash;分页&ndash;&gt;-->
<!--    <div class="pages con_data  ">-->
<!--      <pagination-->
<!--          :pageTotal="pageTotal"-->

<!--      ></pagination>-->
<!--    </div>-->

  </div>
</template>

<script>
import Pagination from '../../components/pagination'
export default {
  name: "company",
  components:{
    Pagination,
  },
  data(){
    return {
      pageIndex: 1, //默认页码
      pageSize:0,//显示条数
      pageTotal: 10, //总条数
      top:'',
      comData:[],
    }
  },
  mounted() {
    this.getInfo();
    this.getTop()
  },
  methods:{
    //获取banner
    getTop() {
      let data = {params: {ImgCate: 9}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect', data).then(res => {
        res = typeof res.data == 'string' ? JSON.parse(res.data) : res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    //获取信息
    getInfo(){
      let data = {params:{NewsCate:0}};
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntNewsSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.comData = res.data;
        console.log(res)
      })
    }
  }
}
</script>

<style scoped>
.row{
  clear: both;
  border-bottom: solid 1px #ddd;
  display: flex;
  justify-content: left;
  padding: 20px 0;
}
.row_img{

}
.bt{
  font-weight: bold;
  font-size: 18px;
  margin: 6px 0;
}
.bt a{
  color: #333;
}
.bt a:hover{
  color: #ff5857;
}
.date{
  font-size: 14px;
  color: #888;
}
.con_text{
  padding-left: 30px;
  box-sizing: border-box;
}
.text{
  color: #555;
  line-height: 25px;
  margin-top: 5px;
}
.pages{
  margin:20px 0;
}
</style>